(function () {
  if (window.__meskiaiParcelyPricesFixV2) return;
  window.__meskiaiParcelyPricesFixV2 = true;

  const TIER_1_MAX = 2998;
  const FREE_SHIPPING_ITEM_THRESHOLD = 2;

  const PRICE_CLASS = "parcely-price-text";
  const OLD_PRICE_CLASS = "parcelly-price-text";

  const PRICES_BY_COUNTRY = {
    LT: {
      lp: { low: "€2.49", mid: "€3.99" },
      omniva: { low: "€2.99", mid: "€4.59" },
      dpd: { low: "€2.89", mid: "€4.49" }
    },
    LV: {
      omniva: { low: "€2.99", mid: "€4.59" },
      unisend: { low: "€2.49", mid: "€3.99" }
    }
  };

  const FREE_TEXT_BY_COUNTRY = {
    LT: "NEMOKAMAI",
    LV: "BEZ MAKSAS"
  };

  const CARRIERS = {
    lp: /lp[\s\-]*express/i,
    omniva: /omniva/i,
    dpd: /\bdpd\b/i,
    unisend: /unisend|uni[\s\-]*send/i
  };

  let cartTotal = 0;
  let cartItemCount = 0;
  let timer = null;
  let lastCountry = "LT";

  function getWidget() {
    return document.querySelector("#parcelyWidget");
  }

  function isVisible(el) {
    return !!(el && el.getClientRects && el.getClientRects().length);
  }

  function normalizeText(text) {
    return String(text || "").replace(/\s+/g, " ").trim();
  }

  function detectCountry() {
    const widget = getWidget();

    if (widget) {
      const countryRow = widget.querySelector(".select_country_row");

      if (countryRow) {
        const alpha = normalizeText(
          countryRow.querySelector(".country_alpha")?.textContent
        ).toUpperCase();

        if (PRICES_BY_COUNTRY[alpha]) {
          lastCountry = alpha;
          return alpha;
        }

        const countryText = normalizeText(countryRow.textContent);

        if (/Latvija|Latvia/i.test(countryText)) {
          lastCountry = "LV";
          return "LV";
        }

        if (/Lietuva|Lithuania/i.test(countryText)) {
          lastCountry = "LT";
          return "LT";
        }
      }
    }

    const shopifyCountry = window.Shopify && window.Shopify.country
      ? String(window.Shopify.country).toUpperCase()
      : "";

    if (PRICES_BY_COUNTRY[shopifyCountry]) {
      lastCountry = shopifyCountry;
      return shopifyCountry;
    }

    return lastCountry;
  }

  function getCartUrl() {
    const root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    return root + "cart.js";
  }

  function fetchCartData() {
    return fetch(getCartUrl(), {
      credentials: "same-origin",
      cache: "no-store"
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        cartTotal = cart.items_subtotal_price || 0;
        cartItemCount = cart.item_count || 0;
      })
      .catch(function () {
        cartTotal = 0;
        cartItemCount = 0;
      });
  }

  function getPrice(country, carrier) {
    const rule = PRICES_BY_COUNTRY[country] && PRICES_BY_COUNTRY[country][carrier];

    if (!rule) return "";

    if (cartItemCount >= FREE_SHIPPING_ITEM_THRESHOLD) {
      return FREE_TEXT_BY_COUNTRY[country] || "NEMOKAMAI";
    }

    return cartTotal < TIER_1_MAX ? rule.low : rule.mid;
  }

  function getCarrier(text) {
    const found = [];

    Object.keys(CARRIERS).forEach(function (key) {
      if (CARRIERS[key].test(text)) {
        found.push(key);
      }
    });

    return found.length === 1 ? found[0] : null;
  }

  function cleanPrices(scope) {
    const root = scope || document;

    root.querySelectorAll("." + PRICE_CLASS + ", ." + OLD_PRICE_CLASS).forEach(function (el) {
      el.remove();
    });
  }

  function getProviderRows() {
    const widget = getWidget();

    if (!widget) return [];

    return Array.from(
      widget.querySelectorAll(".parcely_shipping_provider, .parcelly_shipping_provider")
    ).filter(isVisible);
  }

  function getProviderLabel(row) {
    const directSpan = Array.from(row.children).find(function (child) {
      return child.tagName === "SPAN";
    });

    return directSpan || row.querySelector("span");
  }

  function addPrices() {
    const widget = getWidget();

    if (!widget) return;

    cleanPrices(widget);

    const country = detectCountry();
    const rows = getProviderRows();
    const usedCarriers = {};

    rows.forEach(function (row) {
      const label = getProviderLabel(row);

      if (!label) return;

      const text = normalizeText(label.textContent || row.textContent);

      if (!text || text.length > 120) return;

      const carrier = getCarrier(text);

      if (!carrier) return;
      if (usedCarriers[carrier]) return;

      const price = getPrice(country, carrier);

      if (!price) return;

      usedCarriers[carrier] = true;

      const span = document.createElement("span");
      span.className = PRICE_CLASS;
      span.textContent = " — " + price;
      span.style.cssText =
        "margin-left:4px;white-space:nowrap;font-weight:600;color:#333;font-size:inherit;";

      label.appendChild(span);
    });
  }

  function refresh(delay) {
    clearTimeout(timer);

    timer = setTimeout(function () {
      fetchCartData().then(function () {
        addPrices();

        // Parcely kartais perpiešia bloką šiek tiek vėliau
        setTimeout(addPrices, 500);
        setTimeout(addPrices, 1200);
      });
    }, typeof delay === "number" ? delay : 250);
  }

  document.addEventListener("DOMContentLoaded", function () {
    refresh(100);
  });

  window.addEventListener("pageshow", function () {
    refresh(150);
  });

  document.addEventListener(
    "change",
    function (event) {
      if (
        event.target.closest("#parcelyWidget") ||
        event.target.closest("cart-items") ||
        event.target.closest("#main-cart-items") ||
        event.target.closest("#main-cart-footer")
      ) {
        refresh(250);
      }
    },
    true
  );

  document.addEventListener(
    "click",
    function (event) {
      if (
        event.target.closest("#parcelyWidget") ||
        event.target.closest("cart-items") ||
        event.target.closest("#main-cart-items") ||
        event.target.closest("#main-cart-footer")
      ) {
        refresh(350);
      }
    },
    true
  );

  const observer = new MutationObserver(function (mutations) {
    const onlyOurPricesChanged = mutations.every(function (mutation) {
      const changedNodes = Array.from(mutation.addedNodes).concat(
        Array.from(mutation.removedNodes)
      );

      return (
        changedNodes.length > 0 &&
        changedNodes.every(function (node) {
          return (
            node.nodeType === 1 &&
            node.classList &&
            (node.classList.contains(PRICE_CLASS) ||
              node.classList.contains(OLD_PRICE_CLASS))
          );
        })
      );
    });

    if (onlyOurPricesChanged) return;

    const relevant = mutations.some(function (mutation) {
      const target = mutation.target;

      if (
        target.closest &&
        (
          target.closest("#parcelyWidget") ||
          target.closest("#main-cart-items") ||
          target.closest("#main-cart-footer")
        )
      ) {
        return true;
      }

      return Array.from(mutation.addedNodes).some(function (node) {
        return (
          node.nodeType === 1 &&
          (
            node.matches?.("#parcelyWidget, .parcely_app") ||
            node.querySelector?.("#parcelyWidget, .parcely_app")
          )
        );
      });
    });

    if (relevant) {
      refresh(300);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  refresh(300);
})();